import React from "react";
import "../../styles/card.css";

const Card = ({
  title, children, headerRight, className = "",
}) => (
  <div className={`card ${className}`}>
    <div className="card-header">
      <h3 className="card-title">{title}</h3>
      {headerRight && <div className="card-header-right">{headerRight}</div>}
    </div>
    <div className="card-body">{children}</div>
  </div>
);

export default Card;
